import {StorageService} from '../../services/storage-service.service';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {UserTypeEnum} from '../../store/entities/settings/user/user.model';

@Injectable({
  providedIn: 'root'
})
export class IsStaffGuard {

  constructor(
    private storageService: StorageService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const category = this.storageService.get('category');
      if (category === UserTypeEnum.Staff) {
        return true;
      }
      else if (category === UserTypeEnum.Ministry) {
        return this.router.navigate(['', 'ministry']);
      }
      return this.router.navigate(['', 'login']);
  }
}
